














































































import { Component, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import OpeningHoursService, {
  EDayOfTheWeek,
  IOpeningHoursData,
  IOpeningHoursPeriods
} from '@/api/OpeningHoursService';
import { upperCaseFirstLetter } from '@/utils/string';
import OpeningHourItem from '../Components/OpeningHourItem.vue';
import { FilledButton } from '@/components/molecules';
import segmentIo from '@/utils/segment.io';
import HTTPStatus from '@/constants/httpStatus';
import SelectionBox from '@/componentsV2/molecules/Inputs/SelectionBox.vue';
import DropDownLocations from '@/componentsV2/molecules/DropDownLocations/DropDownLocations.vue';
import { CustomSelectOption } from '@/components/CustomSelect/CustomSelectModel';

@Component({
  components: {
    Typography,
    Checkbox,
    OpeningHourItem,
    FilledButton,
    SelectionBox,
    DropDownLocations
  }
})
export default class HoursOfOperation extends Vue {
  service = new OpeningHoursService();

  hoursList: Record<EDayOfTheWeek, IOpeningHoursData> = {} as Record<
    EDayOfTheWeek,
    IOpeningHoursData
  >;
  loadingList = false;
  enabled = false;
  syncing = false;
  loading = false;
  loadingSubmit = false;
  selectedLocationId?: string = undefined;
  listTobeDeleted: IOpeningHoursPeriods[] = [];

  upperCaseFirstLetter = upperCaseFirstLetter;

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'];
  }

  get disabledLocationFilter() {
    return (
      this.businessInfo.businessLocations &&
      this.businessInfo.businessLocations.length === 1
    );
  }

  get showLocations() {
    return !this.disabledLocationFilter;
  }

  changedLocation(items: CustomSelectOption[]) {
    this.selectedLocationId = items[0].uuid;
    this.loadHours(true);
  }

  async toggleEnabled() {
    this.enabled = !this.enabled;
    segmentIo.track('Hours of Operation | Clicked Toggle Feature', {
      Enabled: this.enabled
    });
    await this.service.toggleOpeningHours(this.enabled);
  }

  async toggleEnabledSync() {
    segmentIo.track('Hours of Operation | Clicked Box Syncronization', {
      Enabled: this.syncing
    });
    await this.service.toggleOpeningHoursSync(this.syncing);
  }

  changeOpen(dayOfTheWeek: EDayOfTheWeek, value: boolean) {
    this.hoursList[dayOfTheWeek].isClosed = !value;
  }

  addNewPeriod(dayOfTheWeek: EDayOfTheWeek, data: IOpeningHoursPeriods) {
    this.hoursList[dayOfTheWeek].periods.push(data);
  }

  changePeriod(
    dayOfTheWeek: EDayOfTheWeek,
    data: IOpeningHoursPeriods,
    column: string,
    value: string
  ) {
    const isNew = !!data.temporaryId;

    this.hoursList[dayOfTheWeek].periods = this.hoursList[
      dayOfTheWeek
    ].periods.map((period: any) => {
      if (
        !this.selectedLocationId &&
        data.businessLocationId &&
        period.businessLocationId &&
        data.businessLocationId !== period.businessLocationId &&
        data.closeTime === period.closeTime &&
        data.openTime === period.openTime
      ) {
        period[column] = value;
      }
      if (
        isNew ? period.temporaryId === data.temporaryId : period.id === data.id
      ) {
        period[column] = value;
      }
      return period;
    });
  }

  deletePeriod(dayOfTheWeek: EDayOfTheWeek, data: IOpeningHoursPeriods) {
    this.hoursList[dayOfTheWeek].periods = this.hoursList[
      dayOfTheWeek
    ].periods.filter(period => {
      if (data.temporaryId) return period.temporaryId !== data.temporaryId;
      if (
        !this.selectedLocationId &&
        data.businessLocationId &&
        period.businessLocationId &&
        data.businessLocationId !== period.businessLocationId &&
        data.closeTime === period.closeTime &&
        data.openTime === period.openTime
      )
        return false;
      return period.id !== data.id;
    });

    if (data.id) {
      segmentIo.track('Hours of Operation | Deleted Period', {
        'Day of the week': dayOfTheWeek,
        'Location Id': this.selectedLocationId
      });
      this.listTobeDeleted.push(data);
    }
  }

  formattedPeriodsResponse(periods: any) {
    const newHour: any = {};

    Object.keys(periods).forEach((item: any) => {
      if (periods[item].periods.length === 0)
        periods[item].periods.push({
          temporaryId: Math.floor(Math.random() * 100000000),
          openTime: '--:--:--',
          closeTime: '--:--:--'
        });
      newHour[item] = {
        ...periods[item],
        periods: periods[item].periods
          .map((period: any) => {
            const emptyTime = period.closeTime === period.openTime;

            return {
              ...period,
              closeTime: emptyTime ? '--:--:--' : period.closeTime,
              openTime: emptyTime ? '--:--:--' : period.openTime
            };
          })
          .filter((period: any) =>
            period.businessLocationId && this.selectedLocationId
              ? period.businessLocationId === this.selectedLocationId
              : true
          )
      };
    });

    return newHour;
  }

  formattedPeriodsRequest(periods: any) {
    const newHour: any = {};

    Object.keys(periods).forEach((item: any) => {
      newHour[item] = {
        ...periods[item],
        periods: periods[item].periods.map((period: any) => {
          return {
            ...(period.id ? period : {}),
            closeTime: period.closeTime.replaceAll('--', '00'),
            openTime: period.openTime.replaceAll('--', '00')
          };
        })
      };
    });

    return newHour;
  }

  dayLabel(day: EDayOfTheWeek) {
    return String(this.$t(`business.hoursOfOperation.days.${day}`));
  }

  isValid() {
    for (const item of Object.keys(this.hoursList) as EDayOfTheWeek[]) {
      if (!this.hoursList[item].isClosed) {
        for (const period of this.hoursList[item].periods) {
          if (
            period.openTime.includes('--') ||
            period.closeTime.includes('--')
          ) {
            this.$notification(
              String(
                this.$t('business.hoursOfOperation.errors.missingTime', {
                  day: this.dayLabel(item)
                })
              ),
              'error'
            );
            return false;
          }

          if (period.openTime === period.closeTime) {
            this.$notification(
              String(
                this.$t('business.hoursOfOperation.errors.sameTime', {
                  day: this.dayLabel(item)
                })
              ),
              'error'
            );
            return false;
          }
        }
      }
    }
    return true;
  }

  async submit() {
    try {
      this.loadingSubmit = true;
      this.$showLoader();
      if (!this.isValid()) return;

      await Promise.all(
        this.listTobeDeleted.map(period => {
          return this.service.deleteOpeningHour(period.id as string);
        })
      );

      this.listTobeDeleted = [];
      const request: any = {
        data: this.formattedPeriodsRequest(this.hoursList),
        enabled: this.enabled
      };

      if (this.selectedLocationId) {
        request.locationId = this.selectedLocationId;
      }

      const response = await this.service.saveOpeningHours(request);
      if (response.status !== HTTPStatus.CREATED) return;

      segmentIo.track('Hours of Operation | Updated Hours', {
        ...Object.keys(this.hoursList).reduce(
          (prev, actual) => ({
            ...prev,
            [`${upperCaseFirstLetter(actual)} Opened`]: !this.hoursList[
              actual as EDayOfTheWeek
            ].isClosed
          }),
          {}
        ),
        'Location Id': this.selectedLocationId
      });
      const { data } = await this.service.getOpeningHours(
        this.selectedLocationId
      );

      this.hoursList = this.formattedPeriodsResponse(data.data);
      this.$notification(
        String(this.$t('business.hoursOfOperation.successNotification'))
      );
    } finally {
      this.$hideLoader();
      this.loadingSubmit = false;
    }
  }

  async loadHours(loadingList?: boolean) {
    try {
      if (!loadingList) this.loading = true;
      else this.loadingList = true;

      this.$showLoader();

      const { data } = await this.service.getOpeningHours(
        this.selectedLocationId
      );

      this.hoursList = this.formattedPeriodsResponse(data.data);
      this.enabled = data.enabled;
      this.syncing = data.enabledGoogleSync;
    } finally {
      this.$hideLoader();
      this.loading = false;
      this.loadingList = false;
    }
  }

  async created() {
    await this.loadHours();
  }
}
